// Scores are on a 0-10 scale
const MASTERY_THRESHOLD = 8;
const ATTENTION_THRESHOLD = 4;

const scoreColorClass = (score) => {
    if (score === null) return "bg-card_dark";
    if (score >= MASTERY_THRESHOLD) return "bg-completed";
    if (score < ATTENTION_THRESHOLD) return "bg-error";
    return "bg-warning";
};

const TeacherPortalConstructPerformanceChart = ({ constructScores, selectedConstructId, onSelectConstruct }) => {
    if (constructScores === null) return <p>Loading class construct performance...</p>;
    if (constructScores.length === 0) return <p>No constructs are available for this course.</p>;

    return (
        <div className="grid grid-cols-[repeat(auto-fit,minmax(210px,1fr))] gap-4">
            {constructScores.map((construct) => {
                const positiveScores = (construct.scores || []).filter((score) => Number.isFinite(score) && score > 0);
                const name = construct.construct_name || `Construct ${construct.constructid}`;
                const averageScore = positiveScores.length
                    ? positiveScores.reduce((total, score) => total + score, 0) / positiveScores.length
                    : null;
                const active = positiveScores.length;
                const total = Math.max(construct.total_students || 0, active);
                const mastered = positiveScores.filter((s) => s >= MASTERY_THRESHOLD).length;
                const needAttention = positiveScores.filter((s) => s < ATTENTION_THRESHOLD).length;
                // Scores are on a 0-10 scale
                const averagePercent = averageScore === null ? null : Math.round(averageScore * 10);

                return (
                    <div
                        key={construct.constructid}
                        role="button"
                        tabIndex={0}
                        onClick={() => onSelectConstruct && onSelectConstruct(construct)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                onSelectConstruct && onSelectConstruct(construct);
                            }
                        }}
                        className={`flex min-h-[116px] min-w-0 cursor-pointer flex-col justify-between rounded-xl p-4 ${construct.constructid === selectedConstructId ? "outline outline-[3px] outline-link" : ""} ${scoreColorClass(averageScore)}`}
                    >
                        <h3 className="break-words font-semibold" title={name}>{name}</h3>
                        <div>
                            <div className="flex items-baseline justify-between">
                                <span className="text-2xl font-semibold">{averagePercent === null ? "–" : `${averagePercent}%`}</span>
                                <span className="text-sm">average score</span>
                            </div>
                            <div className="my-1 h-1.5 rounded bg-black/[0.15]">
                                <div className="h-full rounded bg-bar_average" style={{ width: `${averagePercent || 0}%` }} />
                            </div>
                            <div className="flex justify-between text-sm">
                                <span>&nbsp;</span>
                                <span>{mastered} / {active} mastered</span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TeacherPortalConstructPerformanceChart;